import React from 'react'

import ConsentBadge from './ConsentBadge'

import style from './SectionTitle.module.css'

export default function SectionTitle({
  count,
  index = 0,
  label,
  consentType,
  info,
}) {
  return (
    <>
      <h2
        className={`${style.heading} js-section-title-${index} js-section-title-${label}`}
      >
        <ConsentBadge consentType={consentType}>
          <span className={`${style.count} js-count`}>{count}</span>{' '}
          <span className={`${style.label} js-label`}>{label}</span>{' '}
          <span className="zb-sr-only">agreements</span>
        </ConsentBadge>
      </h2>
      {info && <span className={`${style.info} js-info`}>{info}</span>}
    </>
  )
}
